import { jsx as _jsx } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useObjectContainerLink } from '../../ArbitrationObjects/ContainerArbitrator/useObjectContainerLink';
/** renders a row of item names hyperlinked to the item's details page, responds to ThingViewMap and can be used where UI project has overrides to default containers */
export const ItemLinkList = ({ items, typographyProps, underscoreLinks }) => {
    return items ? (_jsx(Stack, { direction: "row", height: "100%", alignItems: "center", gap: 1, overflow: "auto", children: items.map((item) => (_jsx(ItemLink, { item, typographyProps, underscoreLinks }, item.sk))) })) : null;
};
export const ItemLink = ({ item, typographyProps, style: styleIn, underscoreLinks = false }) => {
    const { link } = useObjectContainerLink({ vob: item });
    const hyperlinkProps = underscoreLinks ? {} : { textDecoration: 'none', color: 'inherit' };
    const style = { ...hyperlinkProps, ...styleIn };
    const typography = _jsx(Typography, { ...typographyProps, children: item.name });
    return link ? (_jsx(Link, { to: link, style: style, children: typography })) : (typography);
};
